import React, { useState, useEffect, useMemo } from "react";
import styles from "../../assets/scss/Invoice/AddItemPopup.module.scss";
import { toast } from "react-toastify";
import Select, { components } from "react-select";

import {
  useGetAllItemCategoriesIdsQuery,
  useSendItemCategoryIdsMutation,
} from "../../slices/admin/admin";

const AddItemCategoriesBelow = ({ onClose, selectedCategoryIds = [] }) => {
  const [itemCategory, setItemCategory] = useState([]);
  const [error, setError] = useState("");

  // 🔥 Get all categories
  const { data, isLoading: isCategoryLoading } =
    useGetAllItemCategoriesIdsQuery();

  // 🔥 Save selected categories
  const [sendItemCategory, { isLoading }] =
    useSendItemCategoryIdsMutation();

  // 🔥 Convert API response → react-select format
  const options = useMemo(() => {
    if (!data?.result) return [];
    return data.result.map((item) => ({
      value: item._id,
      label: item.itemCategory,
    }));
  }, [data]);

  // 🔥 PRESELECT (ID BASE)
  useEffect(() => {
    if (!options.length || !selectedCategoryIds.length) return;

    const preselected = options.filter((opt) =>
      selectedCategoryIds.includes(opt.value)
    );

    setItemCategory(preselected);
  }, [options, selectedCategoryIds]);

  // 🔥 Checkbox inside dropdown
  const CheckboxOption = (props) => (
    <components.Option {...props}>
      <input
        type="checkbox"
        checked={props.isSelected}
        readOnly
        style={{ marginRight: "8px" }}
      />
      <span>{props.label}</span>
    </components.Option>
  );

  // 🔥 Submit handler
  const handleSubmit = async () => {
    if (!itemCategory.length) {
      setError("Please select at least one item category");
      return;
    }

    try {
      const body = {
        itemCategoryIds: itemCategory.map((i) => i.value),
      };

      const response = await sendItemCategory(body).unwrap();

      toast.success(
        response?.message || "Item categories added successfully"
      );

      onClose();
    } catch (err) {
      toast.error(
        err?.data?.message || "Failed to add item categories"
      );
    }
  };

  return (
    <div className={styles.popupForm}>
      <div className={styles.header}>
        <h2 className={styles.tittle}>Add Item Categories</h2>
        <span className={styles.closeIcons} onClick={onClose}>
          X
        </span>
      </div>

      <div className={styles.closeIcon}>
        <div className={styles.grids}>
          <div className={styles.inputGroup}>
            <label className={styles.inputLabel}>Item Categories</label>

            <Select
              isMulti
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              options={options}
              value={itemCategory}
              components={{ Option: CheckboxOption }}
              isLoading={isCategoryLoading}
              getOptionValue={(opt) => opt.value} // 🔥 ID based
              getOptionLabel={(opt) => opt.label}
              placeholder="Select item categories"
              onChange={(val) => {
                setItemCategory(val);
                if (error) setError("");
              }}
              styles={{
                control: (base) => ({
                  ...base,
                  borderColor: error ? "red" : "#ccc",
                  minHeight: "45px",
                  height: "45px",
                }),
                valueContainer: (base) => ({
                  ...base,
                  maxHeight: "40px",
                  overflowY: "auto",
                }),
                menu: (base) => ({
                  ...base,
                  zIndex: 999,
                }),
                menuList: (base) => ({
                  ...base,
                  maxHeight: "150px",
                  overflowY: "auto",
                }),
              }}
            />

            {error && (
              <span style={{ color: "red", fontSize: "12px" }}>
                {error}
              </span>
            )}
          </div>


         
          <div className={styles.inputGroup}>
          </div>
          <div className={styles.inputGroup}>
          </div>
          <div className={styles.inputGroup}>
          </div>
          <div className={styles.inputGroup}>
          </div>
          
          
        
 <div className={styles.footerButtons}>
            <button
              type="button"
              className={styles.cancel}
              onClick={onClose}
            >
              Cancel
            </button>

            <button
              type="button"
              className={styles.save}
              onClick={handleSubmit}
              disabled={isLoading}
            >
              {isLoading ? "Adding..." : "Add"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddItemCategoriesBelow;



